<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="history-details-header">
    <span class="paging-information" id="thpHistoryPagination">Showing {{showingFrom}} to {{showingTo}} of {{history?.length}} records</span>
</div>
<div class="clear"></div>
<div class="history-pages thp-history">
    <div class="thp-history-header" id="thpHistoryHeading">Locomotive Terminal Handling Plan History</div>
    <div class="history-tbl-container">
        <ul id="thpHistoryHeader" class="history-tbl-header">
            <li>Date Time </li>
            <li>Inbound Train </li>
            <li>Planned Activity </li>
            <li>Terminal</li>
            <li>Outbound Train</li>
            <li>Actual Activity</li>
            <li>Event Time</li>
            <li>Compliance</li>
        </ul>
        <div class="thpHistoryTableBody" id="thpHistoryTable" [style.height.px]='scrollHeight' #viewPortPaging=viewPortpaging lmsViewportPaging [child]="'thpHistory-tbl-data'" (getPagingData)="getPagingdata($event);" (scroll)='scrollEventOccured();'>
            <ul class="thpHistory-tbl-data" *ngFor='let thpHistory of historyToShow; let i = index;'>
                <li>
                    {{thpHistory.createDate}} {{thpHistory.createTime}}
                </li>
                <li>
                    <!-- <a *ngIf='appUtilityService.isValidTrainId(thpHistory.inboundTrain); else inboundElse' id="inBoundThp{{i}}{{thpHistory.inboundTrain}}" href="javascript:void(0)" class="menu-item-link" (click)='routeToPage("Data", "Train", thpHistory.inboundTrain);' (contextmenu)='$event.preventDefault(); setOverlayLinks(); locomotiveOverlayPosition($event, thpHistoryOverlay, thpHistory.inboundTrain, i, "inBoundThp")'>
                        {{thpHistory.inboundTrain}}
                    </a>
                    <ng-template #inboundElse>{{thpHistory.inboundTrain}}</ng-template> -->
                    {{thpHistory.inboundTrain}}
                </li>
                <li>
                    {{thpHistory.plannedActivity}}
                </li>
                <li>
                    <!-- <a *ngIf='appUtilityService.isMnemonicExist(thpHistory.terminal); else elseBlock' href="javascript:void(0)" class="menu-item-link" (click)='routeToPage("Status", "Terminal", thpHistory.terminal);'>
                        {{thpHistory.terminal}}
                    </a>
                    <ng-template #elseBlock>{{thpHistory.terminal}}</ng-template> -->
                    {{thpHistory.terminal}}
                </li>
                <li>
                    <!-- <a *ngIf='appUtilityService.isValidTrainId(thpHistory.outboundTrain); else outboundElse' id="outBoundThp{{i}}{{thpHistory.outboundTrain}}" href="javascript:void(0)" class="menu-item-link" (click)='routeToPage("Data", "Train", thpHistory.outboundTrain);'
                        (contextmenu)='$event.preventDefault(); setOverlayLinks(); locomotiveOverlayPosition($event, thpHistoryOverlay, thpHistory.outboundTrain, i, "outBoundThp")'>
                        {{thpHistory.outboundTrain}}
                    </a>
                    <ng-template #outboundElse>{{thpHistory.outboundTrain}}</ng-template> -->
                    {{thpHistory.outboundTrain}}
                </li>
                <li>
                    {{thpHistory.actualActivity}}
                </li>
                <li>
                    {{thpHistory.eventDate}} {{thpHistory.eventTime}}
                </li>
                <li>
                    {{thpHistory.compliance}}
                </li>
            </ul>
        </div>
    </div>
    <div class="clear"></div>
</div>
<p-overlayPanel #thpHistoryOverlay [dismissable]="true" id='thpHistoryOverlayId' [ngClass]="'menu-dropdown'">
    <ul>
        <li *ngFor="let link of overlayLinks">
            <a href="javascript:void(0)" (click)='routeToPage(link, contextType, contextSearchText); hideLocoOverlayPanel($event, thpHistoryOverlay);'>{{link}}</a>
        </li>
    </ul>
</p-overlayPanel>